import { useState, cloneElement } from 'react';
import { addEventToDataLayer } from 'utils/addEventToDataLayer';
import FilterButton from '@sympla/sympla-components/FilterButton';
import { OnSelectFilterParam } from 'ParamsResult';

type FilterWrapperProps = {
  label: string;
  content: React.ReactElement;
  getSelectedItem(...args: unknown[]): void;
  btnType?: 'filter' | 'sort' | undefined;
  nameButton: string;
  activeFilter: OnSelectFilterParam;
};

function FilterWrapper({
  label, content, getSelectedItem, nameButton, activeFilter, btnType = 'filter',
}: FilterWrapperProps) {
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState(activeFilter);

  const hideModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e?.preventDefault();
    e?.stopPropagation();
    setOpen(false);
  };

  const onSelect = (e: OnSelectFilterParam) => {
    setOpen(false);
    setItem(e);
    getSelectedItem(e);
  };

  const handleRemoveItem = (e: OnSelectFilterParam) => {
    setItem(e);
    getSelectedItem(e);
  };

  const testId = `search-filter-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div
      onFocus={() => addEventToDataLayer({
        stckEventCategory: 'consumerInteraction',
        stckEventLabel: label,
      })}
      data-testid={testId}
    >
      <FilterButton
        selectedItem={item?.label}
        onClick={() => setOpen(true)}
        removeSelectedItem={handleRemoveItem}
        btnType={btnType}
        upperCase={false}
      >
        {nameButton}
      </FilterButton>
      {cloneElement(content, {
        open,
        onSelect,
        hideModal,
      })}
    </div>
  );
}

export default FilterWrapper;
